module.exports = __webpack_public_path__ + "img/login-right-1.008c8fc8.svg";